import {ref} from "vue";
import axios from 'axios';
import {useAuthStore, getSessionToken} from "@/stores/authStore";
import {useSubscriptionStore} from "@/stores/subscriptionStore";

export const unreadNotificationsCount = ref(0);
// Set your API base URL
const apiClient = () => {
    const token = getSessionToken();
    return axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        withCredentials: true,
        headers: {
            accept: '*/*',
            'X-Requested-With': 'XMLHttpRequest',
            // Identify the portal explicitly on EVERY request. The API's
            // getPortal() otherwise falls back to the browser Referer, which is
            // intermittently stripped on cross-origin XHR; when that happens it
            // returns null and the auth gate (Authenticate.php) deletes the
            // user's session and 401s, hard-logging the user out. Sending
            // X-Portal makes portal resolution deterministic. X-Client-Source
            // mirrors the login call for consistency.
            'X-Portal': 'personal',
            'X-Client-Source': 'web',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        },
    });
}

export const send = (method, endpoint, data = null, config = {}) => {
    const authUser = JSON.parse(localStorage.getItem('auth'));
    const client = apiClient();
    let response = null;
    switch (method.toLowerCase()) {
        case 'get':
            response = client.get(endpoint, {params: data, ...config});
            break;
        case 'put':
        case 'post':
            response = client[method.toLowerCase()](endpoint, data, config);
            break;
        case 'delete':
            response = client.delete(endpoint, data);
            break;
    }
    return processResponse(authUser, response);
}

const processResponse = (authUser, response) => {
    return response.then((result) => {
        const signature = result.headers.get('X-Signature');
        const url = result.request.responseURL;
        const isAuthRoute = url.includes('login') || url.includes('switch-company');

        if (signature) {
            if (isAuthRoute) {
                // Store signature from login/switch-company response
                let auth = JSON.parse(localStorage.getItem('auth'));
                if (auth) {
                    auth.signature = signature;
                    localStorage.setItem('auth', JSON.stringify(auth));
                }
            } else if (authUser?.signature && authUser.signature !== signature) {
                // Identity changed server-side - force logout
                useAuthStore().logout();
            }
        }
        if (result.data.hasOwnProperty('unreadNotifications')) {
            unreadNotificationsCount.value = result.data.unreadNotifications;
        }
        if (result.data.hasOwnProperty('paymentStatus')) {
            try {
                useSubscriptionStore().updateFromPaymentStatus(result.data.paymentStatus);
            } catch (e) {}
        }
        if (result.status === 401 || result.response?.status === 401) {
            useAuthStore().logout();
        }
        return response;
    }).catch((error) => {
        if (error.status === 401 || error.response?.status === 401) {
            useAuthStore().logout();
        }
        throw error; // Important: re-throw so caller can catch too
    });
}
